import { combineReducers } from 'redux';
import auth from './auth'
import alert from './alert'
import facturas from './facturas'
import perfil from './perfil'
import medicos from './medicos'

export default combineReducers({
    auth, alert, facturas, perfil, medicos
})